import React, { Component } from "react";
import { FiSmartphone , FiPenTool , FiUsers , FiMonitor } from "react-icons/fi";
import { Link }  from "gatsby"

const ServiceList = [
    {
        icon: <FiMonitor />,
        title: 'Web Apps',
        url: '/services/#development',
        description: 'From gorgeous, high performance websites to complex web-based business applications.'
    },
    {
        icon: <FiSmartphone />,
        title: 'Mobile Apps',
        url: '/services/#development',        
        description: 'State of the art apps for iOS / Android backed by high performance cloud infrastructure.'
    },
    {
        icon: <FiPenTool />,
        title: 'Digital Design',
        url: '/services/#design',        
        description: 'Beautifully designed user interfaces, branding design, and even print materials.'
    },
    {
        icon: <FiUsers />,
        title: 'Digital Strategy',
        url: '/services/#strategy',        
        description: 'Expertise acquired delivering solutions to the largest companies in the world.'
    }
]

class ServiceTwo extends Component{
    render(){
        let title = 'Services',
        // description = 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.';
        description = 'Roninworks is a one-stop-shop for all of your digital technology needs. Our talented team of experts can handle every aspect of your project with ease.'
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                            <div className="service-btn">
                                <a className="btn-transparent rn-btn-dark" href="/contact"><span className="text">Looking for Something Else?</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                                    {/* <Link to="/services/"> */}
                                    <Link to={val.url}>
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
